import React from 'react';
import ReactDOM from 'react-dom';
let x = 0;
class Banner extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {bannerBottom: "",buttonClass: "buttonOff", textClass: ""};
        this.secondState = {bannerTop : "Unleash Unlimited"};
    }

    componentDidMount(){
        this.stateID = setInterval(() => this.change(), 1250);
    }
    componentWillUnmount() {
        clearInterval(this.stateID);
      }
    
    change(){
        if(x < 5){
            //console.log(x);
            if( x == 0){
                this.setState({
                    bannerBottom: "Development"
                    });
                    x++;
            }

           else if( x == 1){
                this.setState({
                    bannerBottom: "Designs"
                    });
                    x++;
            }

           else if( x == 2){
                this.setState({
                    bannerBottom: "Features"
                    });
                    x++;
            }

            else if( x == 3){
                this.setState({
                    bannerBottom: "Copywriting"
                    });
                    x++;
            }
            else if( x == 4 | x == 5){
                this.setState({
                    bannerBottom: "Growth"
                    });
                    x++;
            }
            
            
        }
        
        else{
            /*this.button = {classes: "buttonOff buttonOn "}*/
            this.setState({
                buttonClass: "buttonOff buttonOn", textClass: "Fade"
                });
            
        }
    }
    time() {
        var d = new Date();
        var n = d.getHours().toString() + ":" +d.getMinutes().toString();
        return n;
    }

    render(props){
        return(
            <div className="Banner">
                {/*<div className="Banner-top">
                    <div className="Banner-top-text"><h1>{this.secondState.bannerTop}</h1></div>
                </div>
                <div className="Banner-bottom">
                    <div className="Banner-bottom-text"> <h1 className={this.state.textClass}>{this.state.bannerBottom}</h1></div>
                    <a className={this.state.buttonClass} onClick={this.props.link}>Explore Offers</a>
        </div>*/}
                <div className="Banner-top">
                    <div className="Banner-top-text"><h1>Web Development<br></br> Marketing <br></br> IT Support <br></br><span Style={"color:#00bfa5;"}>Like You've Never Experienced.</span></h1></div>
                    <div className="Banner-top-image">
                        {/** Vectorial starts  */}
                        <svg
   xmlnsDc="http://purl.org/dc/elements/1.1/"
   xmlnsCc="http://creativecommons.org/ns#"
   xmlnsRdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlnsSvg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   Style={"background-color:rgba(255,255,255,0)"}
   text-rendering="geometricPrecision"
   shape-rendering="geometricPrecision"
   viewBox="0 0 198.1853 396.25"
   id="exuHLO3meI61">
  <metadata
     id="metadata218">
    <rdfRDF>
      <ccwork
         rdfAbout="">
        <dcformat>image/svg+xml</dcformat>
        <dctype
           rdfResource="http://purl.org/dc/dcmitype/StillImage" />
        <dctitle></dctitle>
      </ccwork>
    </rdfRDF>
  </metadata>
  <style
     id="style2"> {"#exuHLO3meI69_ts {animation: exuHLO3meI69_ts__ts 10000ms linear 1 normal forwards;} @keyframes exuHLO3meI69_ts__ts { 0% {transform: translate(185.952021px,402.809413px) rotate(180deg) scale(-0.000215,1.012111)} 67% {transform: translate(185.952021px,402.809413px) rotate(180deg) scale(-0.000215,1.012111)} 70% {transform: translate(185.952021px,402.809413px) rotate(180deg) scale(1.006457,1.012111)} 73% {transform: translate(185.952021px,402.809413px) rotate(180deg) scale(1.018691,1.000875)} 100% {transform: translate(185.952021px,402.809413px) rotate(180deg) scale(1.018691,1.000875)}} #exuHLO3meI645_to {animation: exuHLO3meI645_to__to 10000ms linear 1 normal forwards} @keyframes exuHLO3meI645_to__to { 0% {transform: translate(-17.498047px,507.137498px)} 2% {transform: translate(-17.498047px,453.125735px)} 12% {transform: translate(-17.498047px,453.125735px)} 14% {transform: translate(-17.49804px,420.71868px)} 22% {transform: translate(-17.49804px,420.71868px)} 24% {transform: translate(-17.49804px,372.798247px)} 28% {transform: translate(-17.49804px,372.798247px)} 30% {transform: translate(-17.49804px,372.798247px)} 32% {transform: translate(-17.498039px,313.218579px)} 35% {transform: translate(-17.498039px,313.218579px)} 41% {transform: translate(-17.498039px,313.218579px)} 43% {transform: translate(-17.498039px,283.897909px)} 49% {transform: translate(-17.498039px,283.897909px)} 55% {transform: translate(-17.498039px,283.897909px)} 57% {transform: translate(-17.498039px,246.861272px)} 65% {transform: translate(-17.498039px,246.861272px)} 66% {transform: translate(-17.498039px,185.391281px)} 68% {transform: translate(-17.498039px,185.391281px)} 100% {transform: translate(-17.498039px,185.391281px)}} #exuHLO3meI646 {animation: exuHLO3meI646_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI646_c_o { 0% {opacity: 0} 55% {opacity: 0} 56% {opacity: 0} 57% {opacity: 1} 100% {opacity: 1}} #exuHLO3meI651 {animation: exuHLO3meI651_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI651_c_o { 0% {opacity: 0} 41% {opacity: 0} 42% {opacity: 0} 43% {opacity: 1} 100% {opacity: 1}} #exuHLO3meI656 {animation: exuHLO3meI656_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI656_c_o { 0% {opacity: 0} 30% {opacity: 0} 31% {opacity: 0} 32% {opacity: 1} 100% {opacity: 1}} #exuHLO3meI663 {animation: exuHLO3meI663_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI663_c_o { 0% {opacity: 0} 23% {opacity: 0} 24% {opacity: 0} 25% {opacity: 1} 100% {opacity: 1}} #exuHLO3meI669 {animation: exuHLO3meI669_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI669_c_o { 0% {opacity: 0} 12% {opacity: 0} 13% {opacity: 0} 14% {opacity: 1} 100% {opacity: 1}} #exuHLO3meI674 {animation: exuHLO3meI674_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI674_c_o { 0% {opacity: 0} 1% {opacity: 0} 2% {opacity: 1} 100% {opacity: 1}} #exuHLO3meI679 {animation: exuHLO3meI679_c_o 10000ms linear 1 normal forwards}@keyframes exuHLO3meI679_c_o { 0% {opacity: 0} 69% {opacity: 0} 73% {opacity: 1} 100% {opacity: 1}}"}
         
     </style>
  <defs
     id="defs54">
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="198.125399"
       x2="196.871108"
       y1="198.125399"
       x1="1.457497"
       id="exuHLO3meI62-fill">
      <stop
         stop-color="#161619"
         offset="0%"
         id="exuHLO3meI62-fill-0" />
      <stop
         stop-color="#27262b"
         offset="100%"
         id="exuHLO3meI62-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="198.124889"
       x2="194.071698"
       y1="198.124889"
       x1="4.256798"
       id="exuHLO3meI63-fill">
      <stop
         stop-color="#bcbec0"
         offset="1.24%"
         id="exuHLO3meI63-fill-0" />
      <stop
         stop-color="#e6e7e8"
         offset="100%"
         id="exuHLO3meI63-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="198.125399"
       x2="193.371998"
       y1="198.125399"
       x1="4.956497"
       id="exuHLO3meI64-fill">
      <stop
         stop-color="#e6e7e8"
         offset="0%"
         id="exuHLO3meI64-fill-0" />
      <stop
         stop-color="#bcbec0"
         offset="98.76%"
         id="exuHLO3meI64-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="-6.0228"
       x2="104.554988"
       y1="391.452489"
       x1="94.058598"
       id="exuHLO3meI66-fill">
      <stop
         stop-color="#161619"
         offset="0%"
         id="exuHLO3meI66-fill-0" />
      <stop
         stop-color="#27262b"
         offset="100%"
         id="exuHLO3meI66-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="1.486999"
       x2="3.644102"
       y1="1.486999"
       x1="-0.000399"
       id="exuHLO3meI610-fill">
      <stop
         stop-color="#161619"
         offset="0%"
         id="exuHLO3meI610-fill-0" />
      <stop
         stop-color="#27262b"
         offset="100%"
         id="exuHLO3meI610-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="1.486999"
       x2="3.64459"
       y1="1.486999"
       x1="-0.0004"
       id="exuHLO3meI611-fill">
      <stop
         stop-color="#161619"
         offset="0%"
         id="exuHLO3meI611-fill-0" />
      <stop
         stop-color="#27262b"
         offset="100%"
         id="exuHLO3meI611-fill-1" />
    </linearGradient>
    <radialGradient
       gradientTransform="matrix(0.656365 -0.754443 1.030928 0.896907 -3.154273 -2.696967)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       r="2.604167"
       cy="0"
       cx="0"
       id="exuHLO3meI614-fill" />
    <radialGradient
       gradientTransform="matrix(0.632782 -1.100616 1.618759 0.930681 2.416021 2.416284)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       r="2.604167"
       cy="0"
       cx="0"
       id="exuHLO3meI615-fill" />
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="1.48731"
       x2="3.644902"
       y1="1.48731"
       x1="0.000302"
       id="exuHLO3meI617-fill">
      <stop
         stop-color="#161619"
         offset="0%"
         id="exuHLO3meI617-fill-0" />
      <stop
         stop-color="#27262b"
         offset="100%"
         id="exuHLO3meI617-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="1.48731"
       x2="3.64421"
       y1="1.48731"
       x1="-0.00029"
       id="exuHLO3meI618-fill">
      <stop
         stop-color="#161619"
         offset="0%"
         id="exuHLO3meI618-fill-0" />
      <stop
         stop-color="#27262b"
         offset="100%"
         id="exuHLO3meI618-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="17.785995"
       x2="118.233398"
       y1="17.785995"
       x1="81.203098"
       id="exuHLO3meI619-fill">
      <stop
         stop-color="#27262b"
         offset="0%"
         id="exuHLO3meI619-fill-0" />
      <stop
         stop-color="#161619"
         offset="100%"
         id="exuHLO3meI619-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="89.380756"
       x2="162.217873"
       y1="107.974661"
       x1="49.427472"
       id="exuHLO3meI647-fill">
      <stop
         stop-color="#fc5f9f"
         offset="0%"
         id="exuHLO3meI647-fill-0" />
      <stop
         stop-color="#f6896a"
         offset="100%"
         id="exuHLO3meI647-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="147.453109"
       x2="26.124998"
       y1="132.753636"
       x1="92.702608"
       id="exuHLO3meI652-fill">
      <stop
         stop-color="#00bfa5"
         offset="0%"
         id="exuHLO3meI652-fill-0" />
      <stop
         stop-color="rgba(0,170,0,0.610092)"
         offset="100%"
         id="exuHLO3meI652-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="89.380756"
       x2="162.217873"
       y1="107.974661"
       x1="49.427472"
       id="exuHLO3meI657-fill">
      <stop
         stop-color="#fc5f9f"
         offset="0%"
         id="exuHLO3meI657-fill-0" />
      <stop
         stop-color="#f6896a"
         offset="100%"
         id="exuHLO3meI657-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="89.380756"
       x2="162.217873"
       y1="107.974661"
       x1="49.427472"
       id="exuHLO3meI664-fill">
      <stop
         stop-color="#fc5f9f"
         offset="0%"
         id="exuHLO3meI664-fill-0" />
      <stop
         stop-color="#f6896a"
         offset="100%"
         id="exuHLO3meI664-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="147.453109"
       x2="26.124998"
       y1="132.753636"
       x1="92.702608"
       id="exuHLO3meI670-fill">
      <stop
         stop-color="#00bfa5"
         offset="0%"
         id="exuHLO3meI670-fill-0" />
      <stop
         stop-color="rgba(0,170,0,0.610092)"
         offset="100%"
         id="exuHLO3meI670-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="userSpaceOnUse"
       spreadMethod="pad"
       y2="89.380756"
       x2="162.217873"
       y1="107.974661"
       x1="49.427472"
       id="exuHLO3meI675-fill">
      <stop
         stop-color="#fc5f9f"
         offset="0%"
         id="exuHLO3meI675-fill-0" />
      <stop
         stop-color="#f6896a"
         offset="100%"
         id="exuHLO3meI675-fill-1" />
    </linearGradient>
    <linearGradient
       gradientTransform="translate(0 0)"
       gradientUnits="objectBoundingBox"
       spreadMethod="pad"
       y2="0.5"
       x2="1"
       y1="0.5"
       x1="0"
       id="exuHLO3meI680-fill">
      <stop
         stop-color="#63cb63"
         offset="0%"
         id="exuHLO3meI680-fill-0" />
      <stop
         stop-color="#00bfa5"
         offset="100%"
         id="exuHLO3meI680-fill-1" />
    </linearGradient>
  </defs>
  <path
     id="path56"
     fill="url(#exuHLO3meI62-fill)"
     transform="translate(.000001 0)"
     d="M166.4308,396.25h-134.533c-16.812,0-30.44-13.629-30.44-30.44v-335.37C1.4578,13.628,15.0858,0,31.8978,0h134.533c16.812,0,30.44,13.629,30.44,30.44v335.37c0,16.811-13.629,30.44-30.44,30.44Z" />
  <path
     id="path58"
     fill="url(#exuHLO3meI63-fill)"
     transform="translate(.000001 0)"
     d="M31.8978,393.451c-15.241,0-27.641-12.399-27.641-27.641v-335.37c0-15.241,12.4-27.641,27.641-27.641h134.533c15.241,0,27.641,12.4,27.641,27.641v335.37c0,15.241-12.4,27.641-27.641,27.641Z" />
  <path
     id="path60"
     fill="url(#exuHLO3meI64-fill)"
     transform="translate(.000001 0)"
     d="M31.8978,392.751c-14.855,0-26.941-12.087-26.941-26.941v-335.37c0-14.855,12.086-26.941,26.941-26.941h134.533c14.855,0,26.941,12.086,26.941,26.941v335.37c0,14.854-12.086,26.941-26.941,26.941Z" />
  <path
     id="path62"
     fill="#f9f9f9"
     transform="translate(.000001 0)"
     d="M31.8978,391.352c-14.083,0-25.542-11.459-25.542-25.542v-335.37c0-14.083,11.458-25.542,25.542-25.542h134.533c14.083,0,25.542,11.458,25.542,25.542v335.37c0,14.083-11.458,25.542-25.542,25.542Z" />
  <path
     id="path64"
     fill="url(#exuHLO3meI66-fill)"
     transform="translate(.000001 0)"
     d="M31.8978,390.652c-13.698,0-24.842-11.144-24.842-24.842v-335.37c0-13.698,11.144-24.842,24.842-24.842h134.533c13.698,0,24.842,11.144,24.842,24.842v335.37c0,13.698-11.144,24.842-24.842,24.842Z" />
  <path
     id="path66"
     fill="#fff"
     transform="matrix(1.012175 0 0 1-1.207091 2.214)"
     d="M184.9748,30.439v335.37c0,10.23-6.666068,17.508966-16.886068,17.508966h-134.54c-10.22,0-20.193932-7.278966-20.193932-17.508966v-335.37c0-10.22,8.32-18.54,18.54-18.54h18.63v1.92c0,6.86,5.56,12.42,12.42,12.42h72.78c6.86,0,12.42-5.56,12.42-12.42v-1.92h18.29c10.22,0,18.54,8.32,18.54,18.54Z" />
  <g
     id="g75"
     transform="translate(-87.035202-46.901001)">
    <g
       transform="translate(185.952021,402.809413) rotate(180) scale(-0.000215,1.012111)"
       id="exuHLO3meI69_ts">
      <path
         id="path68"
         fill="#f5f5f5"
         transform="translate(-99.166016,-41.144531)"
         d="M50.456667,11.546875h-18.406502c-10.096928,0-18.315809,8.321016-18.315809,18.541016v40.654297c0-.002165.001721-.003907.003858-.003907h170.514247v-40.65039c0-10.22-9.184531-18.541016-19.281459-18.541016h-18.070754" />
    </g>
    <rect
       id="rect71"
       fill="url(#exuHLO3meI610-fill)"
       transform="translate(90.476 84.514)"
       ry="0"
       rx="0"
       height="2.974"
       width="3.645" />
    <rect
       id="rect73"
       fill="url(#exuHLO3meI611-fill)"
       transform="translate(278.206 84.514)"
       ry="0"
       rx="0"
       height="2.974"
       width="3.645" />
  </g>
  <circle
     id="circle77"
     fill="#121c28"
     transform="translate(128.906 18.148)"
     r="4.035" />
  <circle
     id="circle79"
     stroke-dashoffset="83.0522"
     stroke-linecap="round"
     stroke-width="23.1"
     fill-opacity="0.018349"
     fill="#040404"
     transform="translate(128.906 18.148)"
     r="2.81894" />
  <circle
     id="circle81"
     stroke-dashoffset="83.0522"
     stroke-linecap="round"
     stroke-width="23.1"
     fill="url(#exuHLO3meI614-fill)"
     transform="translate(128.906 18.148)"
     r="2.60417" />
  <circle
     id="circle83"
     stroke-dashoffset="83.0522"
     stroke-linecap="round"
     stroke-width="23.1"
     fill="url(#exuHLO3meI615-fill)"
     transform="translate(128.906 18.148)"
     r="2.60417" />
  <g
     id="g89"
     transform="translate(-87.035202-46.901001)">
    <rect
       id="rect85"
       fill="url(#exuHLO3meI617-fill)"
       transform="translate(90.548 403.001)"
       ry="0"
       rx="0"
       height="2.975"
       width="3.645" />
    <rect
       id="rect87"
       fill="url(#exuHLO3meI618-fill)"
       transform="translate(277.929 403.001)"
       ry="0"
       rx="0"
       height="2.975"
       width="3.645" />
  </g>
  <path
     id="path91"
     fill="url(#exuHLO3meI619-fill)"
     d="M116.4398,19.579h-33.443c-.99,0-1.793-.803-1.793-1.793v0c0-.99.803-1.793,1.793-1.793h33.443c.99,0,1.793.803,1.793,1.793v0c.001.991-.803,1.793-1.793,1.793Z" />
  <path
     id="path93"
     fill="#181818"
     d="M118.0338,16.963c-.252-.126-.532-.203-.826-.203h-33.449c-.49,0-.938.203-1.267.525-.322.322-.525.77-.525,1.267c0,.301.077.581.203.826-.574-.301-.966-.896-.966-1.588c0-.497.203-.945.525-1.273.322-.322.77-.525,1.267-.525h33.442c.693-.002,1.295.39,1.596.971Z" />
  <rect
     id="rect95"
     stroke-dashoffset="83.0522"
     stroke-linecap="round"
     stroke-width="23.1"
     fill-opacity="0.06422"
     fill="#121c28"
     transform="translate(125.107 15.451)"
     ry="0"
     rx="0"
     height="0.214777"
     width="0.64433" />
  <path
     id="path97"
     fill="#f5f5f5"
     transform="matrix(1.006448 0 0 1.012111-1.131273-.501994)"
     d="M31.894531,11.546875c-10.22,0-18.539062,8.321016-18.539062,18.541016v40.654297c0-.002165.001742-.003907.003906-.003907h172.592657v-40.65039c0-10.22-9.296482-18.541016-19.516482-18.541016h-18.29102v1.919922c0,6.86-5.55992,12.419922-12.41992,12.419922h-72.779298c-6.859999,0-12.419921-5.559922-12.419921-12.419922v-1.919922h-18.63086Z" />
  <text
     id="text101"
     transform="translate(24.666033 26.927818)"
     font-weight="800"
     font-size="8"
     fill="#00bfa5"
     font-family="&quot;sans-serif&quot;"
     dy="0"
     dx="0">
    <tspan
       id="tspan99"
       transform="translate(24.666033 26.927818)"
       font-style="normal"
       font-weight="800"
       font-size="8"
       font-family="&quot;sans-serif&quot;">{this.time()}</tspan>
  </text>
  <g
     id="g117">
    <g
       id="g115">
      <text
         id="text105"
         fill="#00bfa5"
         transform="translate(74.187272 68.022109)"
         font-weight="400"
         font-size="7.02608"
         font-family="&quot;sans-serif&quot;"
         dy="0"
         dx="0">
        <tspan
           id="tspan103"
           fill="#00bfa5"
           transform="translate(68.489402 68.022109)"
           font-style="normal"
           font-weight="400"
           font-size="7.02608"
           font-family="&quot;sans-serif&quot;">Mixael Contreras</tspan>
      </text>
      <g
         id="g113">
        <circle
           id="circle107"
           stroke-dashoffset="83.0522"
           stroke-linecap="round"
           stroke-width="0.5"
           stroke="#707070"
           fill="#00bfa5"
           transform="translate(99.165 47.9263)"
           r="11.1389" />
        <text
           id="text111"
           stroke-width="0"
           fill="#fff"
           transform="translate(90.428421 52.253393)"
           font-weight="700"
           font-size="11.4174"
           dy="0"
           dx="0">
          <tspan
             id="tspan109"
             stroke-width="0"
             fill="#fff"
             transform="translate(89.027779 55.076813)"
             font-style="normal"
             font-weight="700"
             font-size="11.4174"
             font-family="&quot;&quot;Segoe UI&quot;&quot;">MC</tspan>
        </text>
      </g>
    </g>
  </g>
  <g
     id="g135">
    <g
       id="g125">
      <path
         id="path119"
         stroke-dashoffset="83.0522"
         stroke-linecap="round"
         fill="#00bf3e"
         transform="translate(0 0.000001)"
         d="M167.72648,19.247732v.04608c.0183-.0162.0375-.03092.0567-.04608Zm1.1714,0c-.64903-.000001-1.1714.522363-1.1714,1.171395v2.927603c0,.649031.52237,1.171395,1.1714,1.171395h5.56103v-5.270393Zm-1.1714,5.224317v.04608h.0567c-.0192-.01515-.0384-.02988-.0567-.04608Z" />
      <path
         id="path121"
         stroke-dashoffset="83.0522"
         stroke-linecap="round"
         fill="#00bfa5"
         opacity="0.539"
         d="M168.32805,18.666132c-.79245,0-1.42969.637236-1.42969,1.429687v3.574219c0,.792451.63724,1.429687,1.42969,1.429687h7.08398c.79245,0,1.42969-.637236,1.42969-1.429687v-3.574219c0-.792451-.63724-1.429687-1.42969-1.429687Zm.3457.3125h6.39258c.71531,0,1.29101.575705,1.29101,1.291015v3.226563c0,.715309-.5757,1.291015-1.29101,1.291015h-6.39258c-.71531,0-1.29102-.575706-1.29102-1.291015v-3.226563c0-.71531.57571-1.291015,1.29102-1.291015Z" />
      <path
         id="path123"
         stroke-dashoffset="83.0522"
         stroke-linecap="round"
         fill="#00bfa5"
         opacity="0.539"
         transform="translate(0 0.000001)"
         d="M176.84172,20.425897v2.914063h.15234c.35893,0,.64844-.289508.64844-.648438v-1.617187c0-.35893-.28951-.648438-.64844-.648438Z" />
    </g>
    <rect
       id="rect127"
       stroke-dashoffset="83.0522"
       stroke-linecap="round"
       stroke-width="0.2"
       fill="#00bf3e"
       transform="translate(150.655 23.2397)"
       ry="0.007813"
       rx="0.007813"
       height="1.75999"
       width="1.75999" />
    <rect
       id="rect129"
       stroke-dashoffset="83.0522"
       stroke-linecap="round"
       stroke-width="0.2"
       fill="#00bf3e"
       transform="translate(153.031 21.4797)"
       ry="0.015625"
       rx="0.015625"
       height="3.51999"
       width="1.75999" />
    <rect
       id="rect131"
       stroke-dashoffset="83.0522"
       stroke-linecap="round"
       stroke-width="0.2"
       fill="#00bf3e"
       transform="translate(155.407 19.7197)"
       ry="0.015625"
       rx="0.015625"
       height="5.27999"
       width="1.75999" />
    <rect
       id="rect133"
       stroke-dashoffset="83.0522"
       stroke-linecap="round"
       stroke-width="0.2"
       fill="#c3ffd5"
       transform="translate(157.783 17.9597)"
       ry="0.003906"
       rx="0.003906"
       height="7.03998"
       width="1.75999" />
  </g>
  <path
     id="path137"
     stroke-opacity="0.995413"
     stroke-width="0.3"
     stroke="#cdcaca"
     fill="none"
     d="M13.355469,70.738495h171.619141Z" />
  <path
     id="path139"
     stroke="#000"
     fill="none"
     d="" />
  <path
     id="path141"
     stroke-linejoin="round"
     stroke-linecap="round"
     stroke="#707070"
     fill="none"
     d="M40.44268,58.482832l-6.878383-7.139547l6.90467-7.166832" />
  <g
     transform="translate(-17.498047,507.137498)"
     id="exuHLO3meI645_to">
    <g
       id="g203"
       transform="translate(17.498047,-188.765289)">
      <g
         opacity="0"
         transform="translate(.000002 207.873853)"
         id="exuHLO3meI646">
        <path
           id="path143"
           stroke-dashoffset="83.0522"
           stroke-linejoin="round"
           stroke-linecap="round"
           stroke-opacity="0.995413"
           stroke-width="0.3"
           fill="url(#exuHLO3meI647-fill)"
           d="M84.46445,82.310545c-3.04917,0-5.50391,2.58197-5.50391,5.789178v18.924717c0,3.20721,2.45474,5.78918,5.50391,5.78918h84.89492c1.27321,0,2.44061-.45416,3.3711-1.21207.95186.61712,2.98079,1.11418,7.1582,1.05594c0,0-3.65061-.63918-5.04101-5.30229.006-.11008.0156-.21907.0156-.33076v-18.924717c0-3.207208-2.45474-5.789178-5.50391-5.789178Z" />
        <text
           id="text149"
           stroke-width="0"
           fill="#f7f0f0"
           transform="translate(84.105977 94.717177)"
           font-weight="400"
           font-size="11"
           font-family="&quot;exuHLO3meI61:::Roboto&quot;"
           dy="0"
           dx="0">
          <tspan
             id="tspan145"
             stroke-width="0"
             font-weight="400"
             y="0">That was so easy!</tspan>
          <tspan
             id="tspan147"
             stroke-width="0"
             font-weight="400"
             y="11"
             x="0">Thank you!</tspan>
        </text>
      </g>
      <g
         opacity="0"
         transform="translate(-.952193 116.212091)"
         id="exuHLO3meI651">
        <path
           id="path152"
           stroke-dashoffset="83.0522"
           stroke-linejoin="round"
           stroke-linecap="round"
           stroke-opacity="0.995413"
           stroke-width="0.3"
           fill="url(#exuHLO3meI652-fill)"
           transform="translate(.952201 20.745788)"
           d="M147.863282,122.789074c3.049171,0,5.503911,2.45474,5.503911,5.5039l-.000003,13.804676c0,3.04917-2.45474,5.50391-5.50391,5.50391h-121.49218c-1.27321,0-2.44061-.43178-3.3711-1.15234-.95186.58671-2.98079,1.05927-7.1582,1.0039c0,0,3.65061-.60768,5.04101-5.04101-.0059-.10466-.01562-.20828-.01562-.31446l.000003-13.804676c0-3.04916,2.45474-5.5039,5.50391-5.5039Z" />
        <text
           id="text158"
           stroke-width="0"
           fill="#f7f0f0"
           transform="translate(26.702633 154.447266)"
           font-weight="400"
           font-size="10"
           font-family="&quot;exuHLO3meI61:::Roboto&quot;"
           dy="0"
           dx="0">
          <tspan
             id="tspan154"
             stroke-width="0"
             font-weight="400"
             y="0">Done! You should be able to</tspan>
          <tspan
             id="tspan156"
             stroke-width="0"
             font-weight="400"
             y="10"
             x="0">see the changes now.</tspan>
        </text>
      </g>
      <g
         opacity="0"
         transform="translate(10.170689-6.063908)"
         id="exuHLO3meI656">
        <path
           id="path161"
           stroke-dashoffset="83.0522"
           stroke-linejoin="round"
           stroke-linecap="round"
           stroke-opacity="0.995413"
           stroke-width="0.3"
           fill="url(#exuHLO3meI657-fill)"
           transform="matrix(1 0 0 1.405066-13.314249 103.542411)"
           d="M93.251993,74.273919c-3.049168,0-5.503908,2.58197-5.503908,5.789178l-.00002,26.961343c0,3.20721,2.45474,5.78918,5.503908,5.78918h76.107397c1.27321,0,2.44061-.45416,3.3711-1.21207.95186.61712,2.98079,1.11418,7.1582,1.05594c0,0-3.65061-.63918-5.04101-5.30229.006-.11008.0156-.21907.0156-.33076l.00002-26.961343c0-3.207208-2.45474-5.789178-5.50391-5.789178Z" />
        <text
           id="text165"
           stroke-width="0"
           fill="#f7f0f0"
           transform="translate(83.54194 258.401682)"
           font-weight="400"
           font-size="10"
           font-family="&quot;exuHLO3meI61:::Roboto&quot;"
           dy="0"
           dx="0">
          <tspan
             id="tspan163"
             stroke-width="0"
             font-weight="400"
             y="0">This is the video</tspan>
        </text>
        <g
           id="g171"
           transform="matrix(1.162105 0 0 1-46.465861 5.877868)">
          <rect
             id="rect167"
             stroke-width="0"
             transform="matrix(1.746856 0 0 1 110.176715 206.369617)"
             ry="0"
             rx="0"
             height="34.253959"
             width="37.430355" />
          <polygon
             id="polygon169"
             stroke-width="0"
             fill="#d2dbed"
             transform="matrix(0 0.269706-.269706 0 140.553968 223.496596)"
             points="0,-56.453832 24.445227,-14.113458 48.890453,28.226916 0,28.226916 -48.890453,28.226916 -24.445227,-14.113458 0,-56.453832" />
        </g>
      </g>
      <g
         opacity="0"
         transform="translate(.000001 0)"
         id="exuHLO3meI663">
        <path
           id="path174"
           stroke-dashoffset="83.0522"
           stroke-linejoin="round"
           stroke-linecap="round"
           stroke-opacity="0.995413"
           stroke-width="0.3"
           fill="url(#exuHLO3meI664-fill)"
           transform="matrix(1 0 0 1.405066 0.000001 38.168835)"
           d="M47.867191,82.310545c-3.04917,0-5.50391,2.58197-5.50391,5.789178v18.924717c0,3.20721,2.45474,5.78918,5.50391,5.78918h121.492179c1.27321,0,2.44061-.45416,3.3711-1.21207.95186.61712,2.98079,1.11418,7.1582,1.05594c0,0-3.65061-.63918-5.04101-5.30229.006-.11008.0156-.21907.0156-.33076v-18.924717c0-3.207208-2.45474-5.789178-5.50391-5.789178Z" />
        <text
           id="text182"
           stroke-width="0"
           fill="#f7f0f0"
           transform="translate(48.668809 166.543686)"
           font-weight="400"
           font-size="11"
           font-family="&quot;exuHLO3meI61:::Roboto&quot;"
           dy="0"
           dx="0">
          <tspan
             id="tspan176"
             stroke-width="0"
             font-weight="400"
             y="0">I need to add my new</tspan>
          <tspan
             id="tspan178"
             stroke-width="0"
             font-weight="400"
             y="11"
             x="0">promotional video to the</tspan>
          <tspan
             id="tspan180"
             stroke-width="0"
             font-weight="400"
             y="22"
             x="0">top of my page</tspan>
        </text>
      </g>
      <g
         opacity="0"
         transform="translate(.000001 0)"
         id="exuHLO3meI669">
        <path
           id="path185"
           stroke-dashoffset="83.0522"
           stroke-linejoin="round"
           stroke-linecap="round"
           stroke-opacity="0.995413"
           stroke-width="0.3"
           fill="url(#exuHLO3meI670-fill)"
           transform="translate(0 0.000001)"
           d="M147.86328,118.60156c3.04917,0,5.50391,2.45474,5.50391,5.5039v17.99219c0,3.04917-2.45474,5.50391-5.50391,5.50391h-121.49218c-1.27321,0-2.44061-.43178-3.3711-1.15234-.95186.58671-2.98079,1.05927-7.1582,1.0039c0,0,3.65061-.60768,5.04101-5.04101-.0059-.10466-.01562-.20828-.01562-.31446v-17.99219c0-3.04916,2.45474-5.5039,5.50391-5.5039Z" />
        <text
           id="text191"
           stroke-width="0"
           fill="#f7f0f0"
           transform="translate(25.075659 131.704201)"
           font-weight="400"
           font-size="10"
           font-family="&quot;exuHLO3meI61:::Roboto&quot;"
           dy="0"
           dx="0">
          <tspan
             id="tspan187"
             stroke-width="0"
             font-weight="400"
             y="0">We Got You</tspan>
          <tspan
             id="tspan189"
             stroke-width="0"
             font-weight="400"
             y="10"
             x="0">What do you need changed?</tspan>
        </text>
      </g>
      <g
         opacity="0"
         transform="translate(.000001 0)"
         id="exuHLO3meI674">
        <path
           id="path194"
           stroke-dashoffset="83.0522"
           stroke-linejoin="round"
           stroke-linecap="round"
           stroke-opacity="0.995413"
           stroke-width="0.3"
           fill="url(#exuHLO3meI675-fill)"
           d="M47.867191,82.310545c-3.04917,0-5.50391,2.58197-5.50391,5.789178v18.924717c0,3.20721,2.45474,5.78918,5.50391,5.78918h121.492179c1.27321,0,2.44061-.45416,3.3711-1.21207.95186.61712,2.98079,1.11418,7.1582,1.05594c0,0-3.65061-.63918-5.04101-5.30229.006-.11008.0156-.21907.0156-.33076v-18.924717c0-3.207208-2.45474-5.789178-5.50391-5.789178Z" />
        <text
           id="text200"
           stroke-width="0"
           fill="#f7f0f0"
           transform="translate(47.840689 95.879042)"
           font-weight="400"
           font-size="11"
           font-family="&quot;exuHLO3meI61:::Roboto&quot;"
           dy="0"
           dx="0">
          <tspan
             id="tspan196"
             stroke-width="0"
             font-weight="400"
             y="0">I need to make a change</tspan>
          <tspan
             id="tspan198"
             stroke-width="0"
             font-weight="400"
             y="11"
             x="0">to my website ASAP!</tspan>
        </text>
      </g>
    </g>
  </g>
  <a href="tel:7868017389">
  <g
     opacity="0"
     transform="translate(241.087433-40.75)"
     id="exuHLO3meI679">
    <rect
       id="rect206"
       stroke-dashoffset="83.0522"
       stroke-linejoin="round"
       stroke-linecap="round"
       stroke-opacity="0.995413"
       fill="url(#exuHLO3meI680-fill)"
       transform="translate(-215.337 380.25)"
       ry="14.75"
       rx="14.75"
       height="29.5"
       width="145.5" />
    <text
       id="text210"
       stroke-width="0"
       fill="#fff"
       transform="translate(-209.306894 399.215112)"
       font-weight="400"
       font-size="12"
       font-family="&quot;exuHLO3meI61:::Roboto&quot;"
       dy="0"
       dx="0">
      <tspan
         id="tspan208"
         stroke-width="0"
         font-weight="400"
         y="0">Manage My Website Too!</tspan>
    </text>
  </g></a>
  <style
id="style213">{"@font-face font-family: 'exuHLO3meI61:::Roboto';font-style: normal;font-weight: 400; format('truetype');"}
</style>
</svg>

                    </div>
                </div>

            </div>
            );
    }
    
}
export default Banner;